import React, { useState } from "react";

import { Badge, IconButton } from "@mui/material";
import { Notifications } from "@mui/icons-material";

import { HelpBox } from "@/components/atoms";
import { useNotificationContext } from "@/context";
import { NotificationMenu } from "@/components/molecules";

type NotificationButtonProps = {};

const NotificationButton: React.FC<NotificationButtonProps> = () => {

  const { notifications } = useNotificationContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
    <HelpBox title="Notifications" placement="bottom">
      <IconButton
        sx={{
          borderRadius: "6px"
        }}
        color="default"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge badgeContent={notifications?.length ?? 0} color="error" variant="dot">
          <Notifications fontSize="small" color="inherit" />
        </Badge>
      </IconButton>
    </HelpBox>
    <NotificationMenu anchorEl={anchorEl} onClose={() => setAnchorEl(null)}/>
    </>
  );
};

export default NotificationButton;
